import cssClasses from '../helpers/cssClasses';

/**
 * Export default videoModal.
 */
export default () => {

  // Selectors
  const selectors = {
    trigger: document.querySelectorAll('[js-video-modal="trigger"]'),
    overlay: document.querySelectorAll('[js-video-modal="overlay"]'),
    close: document.querySelectorAll('[js-video-modal="close"]'),
    audioTrigger: document.querySelectorAll('[js-video-modal="audio"]'),
  };

  function init() {
    setEventListeners();
  }

  function setEventListeners() {
    selectors.trigger.forEach((item) => {
      item.addEventListener('click', modalToggle);
    });

    selectors.close.forEach((item) => {
      item.addEventListener('click', modalToggle);
    });

    if( selectors.audioTrigger ){
      selectors.audioTrigger.forEach((item) => {
        item.addEventListener('click', audioToggle);
      });
    }
  }

  function modalToggle(node) {
    const target = node.target.getAttribute('js-video-target');
    const modalTarget = document.querySelector(target);
    modalTarget.classList.toggle(cssClasses.active);
  }

  function audioToggle(node){
    const target = node.target.getAttribute('js-audio-target');
    const videoTarget = document.querySelector(target);
    node.target.classList.toggle(cssClasses.active);

    if(videoTarget.muted){
      videoTarget.muted = false;
    } else {
      videoTarget.muted = true;
    }
  }

  return init();
};
